.zeroStateContainer {
    margin: 15px;
}
